import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constants/Endpoints/EndPoints";
import { FetchRequestHandler } from "../../utils/commonUtilities";

export const fetchTechnologyList = createAsyncThunk(
  "fetchTechnologyList",
  async (practiceId) => {
          const result = await FetchRequestHandler(
            "get",
            `${baseUrl}api/practices/${practiceId}/technologies`
          );
          return result;
        }
);

export const updatedTechnologyList = createAsyncThunk(
  "updatedTechnologyList",
  async ({practiceId, data}) => {
    const result = await FetchRequestHandler(
      "put",
      `${baseUrl}api/practices/${practiceId}/technologies`,
      data
    );
    return result;
  }
)

export const deleteTechnologyList = createAsyncThunk(
  "deleteTechnologyList",
  async ({practiceId, deleteDisplayID}) => {
    const result = await FetchRequestHandler(
      "delete",
      `${baseUrl}api/practices/${practiceId}/technologies/${deleteDisplayID}`
    );
    return result;
  }
)

export const fetchTechnologyCheckList = createAsyncThunk(
  "fetchTechnologyCheckList",
  async () => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/technologies`
    );
    return result;
  }
);
